/* eslint-disable no-undef */
function heapTrack(label, object) {
  heap.track(label, object);
}

export { heapTrack };
